import React from "react";
import { Box, Typography, IconButton, alpha } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useClinicTheme } from "../../theme";
import { COLORS, TYPO } from "../../styles/uiConstants";

/**
 * Drawer / Dialog üst header bileşeni (CLAUDE.md "Drawer Tasarımı"):
 * açık gradient zemin + ikon çipi + başlık + alt metin + kapatma butonu.
 *
 * İkon rengi çip tarafından belirlenir; çağıranın ikona verdiği renk
 * (eski koyu zeminden kalma "white" gibi) ezilir.
 *
 * @param {ReactNode} icon - Sol taraftaki ikon (opsiyonel)
 * @param {string} title - Başlık
 * @param {string} subtitle - Alt başlık (opsiyonel)
 * @param {Function} onClose - Kapatma fonksiyonu
 * @param {string} bgcolor - Vurgu rengi (opsiyonel; yoksa tema primary). Gradient
 *   ve ikon çipi bu tondan türetilir.
 */
export default function DrawerHeader({ icon, title, subtitle, onClose, bgcolor }) {
  const { palette } = useClinicTheme();
  const tone = bgcolor || palette.primary;
  return (
    <Box
      sx={{
        background: `linear-gradient(135deg, ${alpha(tone, 0.08)} 0%, ${COLORS.white} 60%)`,
        borderBottom: `1px solid ${COLORS.slate200}`,
        px: 3,
        py: 2,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        flexShrink: 0,
      }}
    >
      {icon ? (
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 2.5,
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: alpha(tone, 0.1),
            border: `1px solid ${alpha(tone, 0.18)}`,
            color: tone,
            "& svg": {
              color: `${tone} !important`,
              width: "20px !important",
              height: "20px !important",
              fontSize: "20px !important",
            },
          }}
        >
          {icon}
        </Box>
      ) : null}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography noWrap sx={{ fontWeight: 700, fontSize: TYPO.title, color: COLORS.slate800 }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography noWrap sx={{ fontSize: TYPO.subtitle, color: COLORS.slate500 }}>
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      <IconButton
        onClick={onClose}
        aria-label="Kapat"
        sx={{ ml: "auto", color: COLORS.slate500, "&:hover": { bgcolor: COLORS.slate100 } }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
}
